// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2uXCl","question":"Question_question__1wtnd","description":"Question_description__15tdZ"};